import { SIDEBAR_NAVITEMS } from "../constants";

export function getVisibleSidebarItems(allowedRoutes = []) {
  const routes = Array.isArray(allowedRoutes) ? allowedRoutes : [];
  const hasAll = routes.includes("all");

  return SIDEBAR_NAVITEMS.filter((item) => {
    if (item.alwaysVisible) return true;
    
    const isCampusRequestItem = item.routeKey === "campus_requests";
    
    if (hasAll && !item.isLogout && !isCampusRequestItem) return true;

    const keys = item.routeKeys || (item.routeKey ? [item.routeKey] : []);
    if (keys.length === 0) return false;

    return keys.some((key) => routes.includes(key));
  });
}

export function hasRouteAccess(pathname, allowedRoutes = []) {
  const routes = Array.isArray(allowedRoutes) ? allowedRoutes : [];

  const globalPaths = ["/notifications"];
  if (globalPaths.includes(pathname)) return true;

  const item = SIDEBAR_NAVITEMS.find(
    (navItem) => navItem.route === pathname && !navItem.isLogout,
  );

  if (!item) return false;
  if (item.alwaysVisible) return true;

  const isCampusRequestItem = item.routeKey === "campus_requests";

  if (routes.includes("all") && !isCampusRequestItem) return true;

  const keys = item.routeKeys || (item.routeKey ? [item.routeKey] : []);
  return keys.some((key) => routes.includes(key));
}
